(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[293],{

/***/ "7soT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Faq", function() { return Faq; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Faq = function Faq(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 47 47"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M19.795 22.049c0 2.44-1.979 4.422-4.42 4.422s-4.421-1.981-4.421-4.422a4.42 4.42 0 0 1 8.841 0m1.099 10.661c0 6.478-5.519 12.593-5.519 12.593S9.858 39.188 9.858 32.71a5.518 5.518 0 1 1 11.036 0m7.789-30.948c-5.52 0-9.992 4.474-9.992 9.992s4.473 9.992 9.992 9.992c5.519 0 9.991-4.474 9.991-9.992s-4.473-9.992-9.991-9.992m-.705 16.158c-1.058 0-1.832-.615-1.832-1.797 0-1.604 1.339-4.546 1.339-5.426 0-.423-.212-.564-1.092-.6l.177-.635 3.979-.068c-.157.527-1.866 6.271-1.866 6.887 0 .37.105.512.299.512.583 0 1.322-1.463 1.551-1.832l.563.316c-.547 1.252-1.604 2.643-3.118 2.643m1.832-9.618c-.704 0-1.409-.583-1.409-1.356 0-.776.705-1.357 1.409-1.357.705 0 1.409.581 1.409 1.357 0 .773-.704 1.356-1.409 1.356"
  }));
};

/***/ })

}]);